var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"relative z-50",attrs:{"id":"navbar"}},[_c('Topnav',{attrs:{"isMobile":_vm.isMobile}}),_c('Sidenav',{attrs:{"isMobile":_vm.isMobile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }